import React, { useEffect, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteContactusUser,
  listContactusUsers,
} from "../../actions/contactusAction";
import LoadingBox from "../LoadingBox";
import MessageBox from "../MessageBox";

export default function InternshipUserContactusScreen() {
  const contactusList = useSelector((state) => state.contactusList);
  const { loading, error, users } = contactusList;
  const contactusDelete = useSelector((state) => state.contactusDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = contactusDelete;

  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(listContactusUsers({}));
  }, [dispatch, successDelete]);

  const deleteHandler = (user) => {
    if (window.confirm("Are you sure?")) {
      dispatch(deleteContactusUser(user._id));
      setSearchTerm("");
    }
  };
  return (
    <div className="SCREEN-CONTAINER">
      <Header />

      <div
        className="MAIN backgroundcolor-f2f2f2"
        style={{ textAlign: "center" }}
      >
        <h1 style={{ padding: "20px 5px", fontWeight: "600" }}>
          Internship User List
        </h1>

        {loadingDelete && <LoadingBox></LoadingBox>}
        {errorDelete && <MessageBox variant="danger">{errorDelete}</MessageBox>}
        {successDelete && (
          <MessageBox variant="success">
            Internship User Deleted Successfully
          </MessageBox>
        )}

        <div className="searchBox">
          <input
            type="input"
            placeholder="Search data"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
          ></input>
        </div>

        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <div className="scrollTableH">
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>NAME</th>
                <th>Telephone</th>
                <th>EMAIL</th>
                <th>College</th>
                <th>Cource Code</th>
                <th>Year</th>
                <th>refName</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {users
                .filter((val) => {
                  if (searchTerm === "") {
                    return val;
                  } else if (
                    val.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    val.email
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val.courcecode
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val.college
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val.telephone
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val._id.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return val;
                  }
                })
                .map((user) => (
                  <tr key={user._id}>
                    <td>{user._id}</td>
                    <td>{user.name}</td>
                    <td>{user.telephone}</td>
                    <td>{user.email}</td>
                    <td>{user.college}</td>
                    <td>{user.courcecode}</td>
                    <td>{user.year}</td>
                    <td>{user.refName}</td>
                    <td>
                      <button
                        className="adminButton"
                        type="button"
                        onClick={() => deleteHandler(user)}
                      >
                        Delete <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
